import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import FetchPosts from "../Helpers/fetchPosts";

const Context = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get("query") || ""; // Default to empty string if 'query' is not present
  
  // State to trigger re-fetch
  const [refreshKey, setRefreshKey] = useState(0); 

  // Watch for query change and reset the refreshKey
  useEffect(() => {
    // Increment the refresh key to trigger FetchPosts refetch
    setRefreshKey(prevKey => prevKey + 1);
  }, [query]);  // This will trigger whenever the query changes

  return (
    <>
      <div>
        <h2>Posts Within "{query}" Context</h2>
      </div>

      {/* Pass the refreshKey as a key prop to FetchPosts */}
      {/* This forces the component to remount whenever the query changes */}
      <FetchPosts key={refreshKey} context={query} />
    </>
  );
};

export default Context;
